"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M11.0541 11.6994L8.08999 8.85293L3.98046 8.91316L1.02442 11.9254L1.1635 16.0657L4.12764 18.9122L8.23717 18.8519L11.1603 15.808L11.0541 11.6994Z",
      stroke: "currentColor",
      strokeWidth: "1.2",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M15.4789 1.0337L15.8945 0.600937C15.7806 0.49152 15.6281 0.431451 15.4701 0.433766L15.4789 1.0337ZM18.4431 3.88021L19.0429 3.86471C19.0388 3.70679 18.9726 3.55686 18.8587 3.44744L18.4431 3.88021ZM17.9494 8.0043C17.958 8.33556 18.2334 8.59716 18.5647 8.5886C18.896 8.58005 19.1576 8.30457 19.149 7.97331L17.9494 8.0043ZM11.3606 0.494004C11.0293 0.49886 10.7646 0.771398 10.7695 1.10273C10.7743 1.43407 11.0469 1.69873 11.3782 1.69387L11.3606 0.494004ZM15.0633 1.46647L18.0275 4.31297L18.8587 3.44744L15.8945 0.600937L15.0633 1.46647ZM17.8433 3.8957L17.9494 8.0043L19.149 7.97331L19.0429 3.86471L17.8433 3.8957ZM11.3782 1.69387L15.4877 1.63364L15.4701 0.433766L11.3606 0.494004L11.3782 1.69387Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M8 8.99998L15.4038 1.24365",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M3.46566 8.58653C3.23727 8.82663 3.24676 9.20641 3.48686 9.4348C3.72695 9.66319 4.10673 9.6537 4.33512 9.4136L3.46566 8.58653ZM4.33512 9.4136L11.862 1.50094L10.9926 0.673867L3.46566 8.58653L4.33512 9.4136Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11 12L18.5 4.14282",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M18.933 8.54252C19.1624 8.30337 19.1545 7.92355 18.9153 7.69418C18.6762 7.4648 18.2964 7.47272 18.067 7.71188L18.933 8.54252ZM11.5658 16.2237L18.933 8.54252L18.067 7.71188L10.6998 15.393L11.5658 16.2237Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;